<template>
  <v-tooltip top>
    <template v-slot:activator="{ on, attrs }">
      <v-icon
        v-bind="attrs"
        v-on="on"
        :small="small"
        :size="size"
        color="secondarytext"
      >
        $vuetify.icons.core_counts
      </v-icon>
    </template>
    <div class="tooltip-limit-width">
      This segment size is less than our minimum requirement for anonymous data
      to be displayed. We are hiding this data to prevent an employee from
      easily being identified.
    </div>
  </v-tooltip>
</template>

<script>
export default {
  name: "AnonymousIcon",
  props: {
    small: { type: Boolean, default: false },
    size: { type: Number }
  }
};
</script>
